import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Translate } from 'i18n'
import * as routePaths from 'constants/routePaths'
import AppCaptcha from 'components/AppCaptcha'
import './style.css'


const FormFooter = props => (
    <div className='form-footer'>
        { props.isCaptchaEnabled && <AppCaptcha /> }

        <button
            onClick={props.onSave}
            className={`button button_type_alert ${props.isDisabled ? 'button_type_disabled' : ''}`}>
            <Translate value='saveShoppingList' />
        </button>

        <Link
            onClick={props.onSendMail}
            to={routePaths.EMAIL}
            className={`button button_type_secondary button_icon_${!props.isEmailSent || props.isDisabled ? 'send' : 'check'} ${props.isDisabled || props.isEmailSent ? 'button_type_disabled' : ''}`}>

            { !props.isEmailSent || props.isDisabled
                ? <Translate value='emailMeTheList' />
                : <Translate value='emailSent' />
            }

            <span className={`icon icon-${!props.isEmailSent || props.isDisabled ? 'send' : 'check'}`} />
        </Link>
    </div>
)

FormFooter.propTypes = {
    isEmailSent: PropTypes.bool,
    isDisabled: PropTypes.bool.isRequired,
    isCaptchaEnabled: PropTypes.bool,
    onSave: PropTypes.func.isRequired,
    onSendMail: PropTypes.func
}

FormFooter.defaultProps = {
    isCaptchaEnabled: false,
    onSendMail: null
}

export default FormFooter
